import React from "react";
import ScheduleServiceContainer from "../../containers/ScheduleServiceContainer/ScheduleServiceContainer";

const ScheduleServicePage = () => {
  return <ScheduleServiceContainer />;
};

export default ScheduleServicePage;
